export const bars = () => {
  ['d', 'i', 's', 'c'].map((x) => {
    document.getElementById(`builder_${x}`).oninput = (e) => {
      updateBar(x, e.target);
    };
  });

  function updateBar(string, letter) {
    if (letter.value > 100) {
      letter.value = 100;
    }
    document.getElementById(`Bar-${string}`).style.height =
      window.innerWidth > 600
        ? (letter.value / 100) * 300 + 'px'
        : (letter.value / 100) * 140 + 'px';
  }

  return () => {
    updateBar('d', { value: 0 });
    updateBar('i', { value: 0 });
    updateBar('s', { value: 0 });
    updateBar('c', { value: 0 });
  };
};
